import {FC, ReactNode} from 'react'
import clsx from "clsx";
import {tv} from "tailwind-variants";
import {alignment, columnWidth, lightBackgroundColor} from "@/constants/constants";

const generateClasses = tv({
    slots: {
        root: [
            '@container/column',
            'w-full'
        ],
        innerContainer: 'flex flex-col flex-wrap gap-mobile @sm/column:gap-2xl',
        calculatedWidth: '',
        alignment: '',
        color: '',
    },
    variants: {
        align: {
            'left': {
                alignment: 'items-start text-left'
            },
            'center': {
                alignment: 'items-center text-center group/column-center column-center'
            },
            'right': {
                alignment: 'items-end text-right'
            }
        },
        width: {
            '1': {
                calculatedWidth: 'w-full'
            },
            '1/2': {
                calculatedWidth: 'md:w-[calc((50%)-calc(theme(spacing.2xl)/2))] lg:w-[calc((50%)-calc(theme(spacing.3xl)/2))]'
            },
            '1/3': {
                calculatedWidth: 'md:w-[calc((33.3333%)-calc(theme(spacing.2xl)/1.5))] lg:w-[calc((33.3333%)-calc(theme(spacing.3xl)/1.5))]'
            },
            '2/3': {
                calculatedWidth: 'md:w-[calc((66.6666%)-calc(theme(spacing.2xl)/3))] lg:w-[calc((66.6666%)-calc(theme(spacing.3xl)/3))]'
            },
            '1/4': {
                calculatedWidth: 'md:w-[calc((25%)-calc(theme(spacing.2xl)/1.33))] lg:w-[calc((25%)-calc(theme(spacing.3xl)/1.33))]'
            },
            '3/4': {
                calculatedWidth: 'md:w-[calc((75%)-calc(theme(spacing.2xl)/4))] lg:w-[calc((75%)-calc(theme(spacing.3xl)/4))]'
            },
            '2/5': {
                calculatedWidth: 'md:w-[calc((40%)-calc(theme(spacing.2xl)/2))] lg:w-[calc((40%)-calc(theme(spacing.3xl)/2))]'
            },
            '3/5': {
                calculatedWidth: 'md:w-[calc((60%)-calc(theme(spacing.2xl)/2))] lg:w-[calc((60%)-calc(theme(spacing.3xl)/2))]'
            },
        },
        backgroundColor: {
            'light-peach': {
                color: 'bg-brand-light-peach p-mobile md:p-2xl lg:p-3xl group/bgColor bgColor'
            },
            'light-purple': {
                color: 'bg-brand-light-purple p-mobile md:p-2xl lg:p-3xl group/bgColor bgColor'
            },
            'light-blue': {
                color: 'bg-brand-light-blue p-mobile md:p-2xl lg:p-3xl group/bgColor bgColor'
            },
            'light-warm-grey': {
                color: 'bg-brand-light-warm-grey p-mobile md:p-2xl lg:p-3xl group/bgColor bgColor'
            },
            'light-cool-grey': {
                color: 'bg-brand-light-cool-grey p-mobile md:p-2xl lg:p-3xl group/bgColor bgColor'
            },
            'light-green': {
                color: 'bg-brand-light-green p-mobile md:p-2xl lg:p-3xl group/bgColor bgColor'
            },
            'white': {
                color: 'bg-white p-mobile pb-[0] md:pb-[0] lg:pb-[0] md:p-2xl lg:p-3xl group/bgColor bgColor'
            }
        }
    },
});

interface Props {
    children?: ReactNode,
    className?: string,
    backgroundColor?: lightBackgroundColor | 'white'
    width?: columnWidth,
    align?: alignment,
    key?: string
}

const Column: FC<Props> = ({
                               children,
                               className,
                               backgroundColor,
                               align = 'left',
                               width = '1'
                           }) => {

    const {root, calculatedWidth, alignment, color, innerContainer} = generateClasses({
        width,
        align,
        backgroundColor
    });

    return (
        <div className={clsx(root(),
            calculatedWidth(),
            alignment(),
            color(),
            backgroundColor && width === '1'? 'min-h-[400px] content-center': null,
            className
        )}>
            <div className={clsx(alignment(), innerContainer())}>
                {children}
            </div>
        </div>
    )
}

export default Column
